<app-layout [isProducerArea]="true">
  <div class="background">
    <div class="collaborator-success-container">
      @if (!event) {
        <p-skeleton height="2rem" />
        <p-skeleton height="3rem" />
        <p-skeleton height="2rem" />
        <p-skeleton height="3rem" />
        <p-skeleton height="3rem" />
        <p-skeleton height="3rem" />
        <div class="stores">
          <p-skeleton height="10rem" />
          <p-skeleton height="10rem" />
        </div>
      } @else {
        <div class="header">
          <h1>Convite confirmado com sucesso!</h1>
          <mat-icon fontSet="material-symbols-outlined">check_circle</mat-icon>
        </div>
        <p>
          Paranbéns! Você acaba de garantir sua participação como colaborador no evento
          <a [routerLink]="['/event', event.id]">{{ event.title }} (Visualizar página)</a>.
        </p>
        <p>Estamos feliz em contar com você nessa experiência!</p>
        <h2>Baixe o app da Yes7 Tickets</h2>
        <p>
          Para acessar as funções exclusivas do colaborador, como check-in com QR Code, controle de acesso e suporte da
          equipe, <b>você precisará usar o nosso aplicativo oficial.</b>
        </p>

        <div class="message-card">
          <mat-icon>local_activity</mat-icon>
          <span>A versão web não permite o uso completo da câmera do seu celular;</span>
        </div>

        <div class="message-card">
          <mat-icon>local_activity</mat-icon>
          <span>
            Algumas funções essenciais - como escanear QR Code de check-in - funcionam somente com a câmera nativa do
            app;
          </span>
        </div>

        <div class="message-card">
          <mat-icon>local_activity</mat-icon>
          <span>No app, sua experiência será mais rápida, estável e segura.</span>
        </div>

        <p><b>Baixe agora mesmo:</b></p>

        <div class="stores">
          <a href="https://apps.apple.com/br/app/yes7-tickets-produtor/id6758278253">
            <img src="./../../../assets/images/collaborator-app-store.png" alt="Abrir APP Store" />
          </a>

          <a href="https://play.google.com/store/apps/details?id=com.yes7tickets.producer">
            <img src="./../../../assets/images/collaborator-play-store.png" alt="Abrir Play Store" />
          </a>
        </div>
      }
    </div>
  </div>
</app-layout>
